import { EXPERIMENTS } from '@src/experiments'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import useExperimentBucket from '@src/quince-site-common/src/hooks/useExperimentBucket'

export const useIsFeatureSectionTwoHidden = (section: CustomSection | undefined): boolean => {
  const longFormExpBucket = useExperimentBucket(EXPERIMENTS.NEW_LONG_FORM_MODULES.experimentName)
  const isLongFormControl = longFormExpBucket === EXPERIMENTS.NEW_LONG_FORM_MODULES.bucketNames.control

  if (!section) {
    return true
  }

  const { runExperiment, experimentName } = section
  if (runExperiment && experimentName === EXPERIMENTS.NEW_LONG_FORM_MODULES.experimentName) {
    return !isLongFormControl
  }

  return false
}
